import React from 'react';
import { CheckIcon } from 'lucide-react';
export function PricingSection() {
  const plans = [{
    name: 'Basic',
    price: '$19',
    description: 'Perfect for occasional content creators',
    features: ['Transcription of videos up to 30 minutes', 'Blog post generation', 'Basic SEO optimization', '1 language for dubbing', 'Email support'],
    cta: 'Start Basic',
    highlighted: false
  }, {
    name: 'Pro',
    price: '$49',
    description: 'Ideal for regular content creators',
    features: ['Transcription of videos up to 2 hours', 'Advanced blog post formatting', 'Complete SEO optimization', '5 languages for dubbing', 'Priority support', 'Custom voice options'],
    cta: 'Start Pro',
    highlighted: true
  }, {
    name: 'Enterprise',
    price: '$99',
    description: 'For professional content teams',
    features: ['Unlimited video length', 'Advanced blog templates', 'SEO optimization with analytics', 'Unlimited languages for dubbing', '24/7 priority support', 'Custom voice options', 'API access', 'Team collaboration features'],
    cta: 'Contact Sales',
    highlighted: false
  }];
  return <div id="pricing" className="bg-white py-12" data-id="element-173">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-174">
        <div className="lg:text-center" data-id="element-175">
          <h2 className="text-base text-indigo-600 font-semibold tracking-wide uppercase" data-id="element-176">
            Pricing
          </h2>
          <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl" data-id="element-177">
            Simple, transparent pricing
          </p>
          <p className="mt-4 max-w-2xl text-xl text-gray-500 lg:mx-auto" data-id="element-178">
            Choose the plan that fits your content creation needs. All plans
            include our core transcription features.
          </p>
        </div>
        <div className="mt-10 space-y-12 lg:space-y-0 lg:grid lg:grid-cols-3 lg:gap-x-8" data-id="element-179">
          {plans.map(plan => <div key={plan.name} className={`relative p-8 bg-white border rounded-lg shadow-sm flex flex-col ${plan.highlighted ? 'border-indigo-500 ring-2 ring-indigo-500' : 'border-gray-200'}`} data-id="element-180">
              {plan.highlighted && <div className="absolute top-0 inset-x-0 transform -translate-y-1/2" data-id="element-181">
                  <div className="inline-flex px-4 py-1 rounded-full text-sm font-semibold tracking-wider uppercase bg-indigo-100 text-indigo-600" data-id="element-182">
                    Most Popular
                  </div>
                </div>}
              <div className="mb-4" data-id="element-183">
                <h3 className="text-xl font-semibold text-gray-900" data-id="element-184">
                  {plan.name}
                </h3>
                <p className="mt-4 flex items-baseline text-gray-900" data-id="element-185">
                  <span className="text-5xl font-extrabold tracking-tight" data-id="element-186">
                    {plan.price}
                  </span>
                  <span className="ml-1 text-xl font-semibold" data-id="element-187">/month</span>
                </p>
                <p className="mt-2 text-sm text-gray-500" data-id="element-188">{plan.description}</p>
              </div>
              <div className="flex-1" data-id="element-189">
                <ul className="space-y-3" data-id="element-190">
                  {plan.features.map(feature => <li key={feature} className="flex" data-id="element-191">
                      <CheckIcon className="flex-shrink-0 h-5 w-5 text-green-500" aria-hidden="true" data-id="element-192" />
                      <span className="ml-3 text-sm text-gray-500" data-id="element-193">
                        {feature}
                      </span>
                    </li>)}
                </ul>
              </div>
              <div className="mt-8" data-id="element-194">
                <button type="button" className={`w-full inline-flex items-center justify-center px-6 py-3 border border-transparent rounded-md shadow-sm text-base font-medium ${plan.highlighted ? 'text-white bg-indigo-600 hover:bg-indigo-700' : 'text-indigo-700 bg-indigo-100 hover:bg-indigo-200'}`} data-id="element-195">
                  {plan.cta}
                </button>
              </div>
            </div>)}
        </div>
      </div>
    </div>;
}